import { render, staticRenderFns } from "./projectmanagers.vue?vue&type=template&id=dc65b080&"
import script from "./projectmanagers.vue?vue&type=script&lang=js&"
export * from "./projectmanagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports